export default "__VITE_ASSET__D89bxAln__"